/// depends on jquery.numberformatter-1.2.3.js
//todo: switch to https://github.com/jquery/globalize

function formatCurrency(data, type, full) {
    if (type == "display") {
        return formatCurrencyRaw(data);
    }
    else {
        if (null == data) {
            return -1;
        }
        else {
            return data;
        }
    }
}

function formatCurrency_2Decimal(data, type, full) {
    if (type == "display") {
        return formatCurrency2DecimalRaw(data);
    }
    else {
        if (null == data) {
            return -1;
        }
        else {
            return data;
        }
    }
}

function formatNumber(data, type, full) {
    if (type == "display") {
        return formatNumberRaw(data);
    }
    else {
        return data;
    }
}

function formatPercentage_1Decimal(data, type, full) {
    if (type == "display") {
        return formatPercentage1DecimalRaw(data);
    }
    else {
        return data;
    }
}

function formatPercentage_3Decimal(data, type, full) {
    if (type == "display") {
        return formatPercentage3DecimalRaw(data);
    }
    else {
        return data;
    }
}

function formatPercentage(data, type, full) {
    if (type == "display") {
        return formatPercentageRaw(data);
    }
    else {
        return data;
    }
}

function formatPercentage100(data, type, full) {
    if (type == "display") {
        return formatPercentage100Raw(data);
    }
    else {
        if (null == data) {
            return -1;
        }
        else {
            return data;
        }
    }
}

function formatDecimal1(data, type, full) {
    return formatDecimal1Raw(data);
}

function formatDecimal2(data, type, full) {
    return formatDecimal2Raw(data);
}

function formatDecimal3(data, type, full) {
    return formatDecimal3Raw(data);
}

function formatDecimal4(data, type, full) {
    return formatDecimal4Raw(data);
}

function formatCurrencyRaw(o) {
    var rc = "";
    if (o !== null && o !== "") {
        // this number format lib doesn't allow specifing negative formatting
        // so we have to handle it manually
        if (o < 0) {
            rc = "($" + $.formatNumber(o * -1, { format: "#,##0", locale: "us" }) + ")";
        }
        else {
            rc = "$" + $.formatNumber(o, { format: "#,##0", locale: "us" });
        }
    }
    return rc;
}

function formatCurrency2DecimalRaw(o) {
    var rc = "";
    if (o !== null && o !== "") {
        // this number format lib doesn't allow specifing negative formatting
        // so we have to handle it manually
        if (o < 0) {
            rc = "($" + $.formatNumber(o * -1, { format: "#,##0.00", locale: "us" }) + ")";
        }
        else {
            rc = "$" + $.formatNumber(o, { format: "#,##0.00", locale: "us" });
        }
    }
    return rc;
}

function formatNumberRaw(o) {
    var rc = "";
    if (o !== null && o !== "") {
        if (o < 0) {
            rc = "(" + $.formatNumber(o * -1, { format: "#,##0", locale: "us" }) + ")";
        }
        else {
            rc = $.formatNumber(o, { format: "#,##0", locale: "us" });
        }
    }
    return rc;
}

function formatPercentage1DecimalRaw(o) {
    var rc = "";
    if (o !== null && o !== "") {
        if (o < 0) {
            rc = "(" + $.formatNumber(o, { format: "##0.0", locale: "us" }) + "%)";
        }
        else {
            rc = $.formatNumber(o, { format: "##0.0", locale: "us" }) + "%";
        }
    }
    return rc;
}

function formatPercentage3DecimalRaw(o) {
    var rc = "";
    if (o !== null && o !== "") {
        if (o < 0) {
            rc = "(" + $.formatNumber(o, { format: "##0.000", locale: "us" }) + "%)";
        }
        else {
            rc = $.formatNumber(o, { format: "##0.000", locale: "us" }) + "%";
        }
    }
    return rc;
}

function formatPercentage100With2DecimalRaw(o) {
    var rc = "";
    if (o !== null && o !== "") {
        if (o < 0) {
            rc = "(" + $.formatNumber(o * 100, { format: "##0.00", locale: "us" }) + "%)";
        }
        else {
            rc = $.formatNumber(o * 100, { format: "##0.00", locale: "us" }) + "%";
        }
    }
    return rc;
}

function formatPercentageRaw(o) {
    var rc = "";
    if (o !== null && o !== "") {
        if (o < 0) {
            rc = "(" + $.formatNumber(o, { format: "##0", locale: "us" }) + "%)";
        }
        else {
            rc = $.formatNumber(o, { format: "##0", locale: "us" }) + "%";
        }
    }
    return rc;
}

function formatPercentage100Raw(o) {
    var rc = "";
    if (o !== null && o !== "") {
        if (o < 0) {
            rc = "(" + $.formatNumber(o * 100, { format: "##0", locale: "us" }) + "%)";
        }
        else {
            rc = $.formatNumber(o * 100, { format: "##0", locale: "us" }) + "%";
        }
    }
    return rc;
}

function formatDecimal1Raw(o) {
    var rc = "";
    if (o !== null && o !== "") {
        if (o < 0) {
            rc = "(" + $.formatNumber(o * -1, { format: "#,##0.0", locale: "us" }) + ")";
        }
        else {
            rc = $.formatNumber(o, { format: "#,##0.0", locale: "us" });
        }
    }
    return rc;
}

function formatDecimal2Raw(o) {
    var rc = "";
    if (o !== null && o !== "") {
        if (o < 0) {
            rc = "(" + $.formatNumber(o * -1, { format: "#,##0.00", locale: "us" }) + ")";
        }
        else {
            rc = $.formatNumber(o, { format: "#,##0.00", locale: "us" });
        }
    }
    return rc;
}

function formatDecimal3Raw(o) {
    var rc = "";
    if (o !== null && o !== "") {
        if (o < 0) {
            rc = "(" + $.formatNumber(o * -1, { format: "#,##0.000", locale: "us" }) + ")";
        }
        else {
            rc = $.formatNumber(o, { format: "#,##0.000", locale: "us" });
        }
    }
    return rc;
}

function formatDecimal4Raw(o) {
    var rc = "";
    if (o !== null && o !== "") {
        if (o < 0) {
            rc = "(" + $.formatNumber(o * -1, { format: "#,##0.0000", locale: "us" }) + ")";
        }
        else {
            rc = $.formatNumber(o, { format: "#,##0.0000", locale: "us" });
        }
    }
    return rc;
}


/////
/////
// CUSTOM FORMATTERS
// CUSTOM FORMATTERS
// CUSTOM FORMATTERS
/////
/////
//GetCompensationSchedOverview
function CompensationSchedOverviewTier1Formatter(data, type, full) {
    var rc = "";
    var agi = full['AGI1'];
    var comm = full['Comm1'];
    var potdesc = full['PayoutTypeDesc1'];

    rc = '>' + agi + '<br/>' + formatDecimal2Raw(comm);
    if (potdesc != null) {
        rc += ' ' + potdesc;
    }

    return rc;
}

//GetCompensationSchedOverview
function CompensationSchedOverviewTier2Formatter(data, type, full) {
    var rc = "";
    var agi = full['AGI2'];
    var tierTypeAndOr = full['TierTypeAndOr2'];
    var a = full['AGI2a'];
    var comm = full['Comm2'];
    var potdesc = full['PayoutTypeDesc2'];

    if (parseInt(agi) > 0) {
        rc = '>=' + agi + '<br/>';
        if (tierTypeAndOr != null) {
            rc += tierTypeAndOr + ' >=' + a + '<br/>';
        }
        rc += formatDecimal2Raw(comm);
        if (potdesc != null) {
            rc += ' ' + potdesc;
        }
    }

    return rc;
}

//GetCompensationSchedOverview
function CompensationSchedOverviewTier3Formatter(data, type, full) {
    var rc = "";
    var agi = full['AGI3'];
    var tierTypeAndOr = full['TierTypeAndOr3'];
    var a = full['AGI3a'];
    var comm = full['Comm3'];
    var potdesc = full['PayoutTypeDesc3'];

    if (parseInt(agi) > 0) {
        rc = '>=' + agi + '<br/>';
        if (tierTypeAndOr != null) {
            rc += tierTypeAndOr + ' >=' + a + '<br/>';
        }
        rc += formatDecimal2Raw(comm);
        if (potdesc != null) {
            rc += ' ' + potdesc;
        }
    }

    return rc;
}

//GetCompensationSchedOverview
function CompensationSchedOverviewTier4Formatter(data, type, full) {
    var rc = "";
    var agi = full['AGI4'];
    var tierTypeAndOr = full['TierTypeAndOr4'];
    var a = full['AGI4a'];
    var comm = full['Comm4'];
    var potdesc = full['PayoutTypeDesc4'];

    if (parseInt(agi) > 0) {
        rc = '>=' + agi + '<br/>';
        if (tierTypeAndOr != null) {
            rc += tierTypeAndOr + ' >=' + a + '<br/>';
        }
        rc += formatDecimal2Raw(comm);
        if (potdesc != null) {
            rc += ' ' + potdesc;
        }
    }

    return rc;
}

//GetCompensationSchedOverview
function CompensationSchedOverviewTier5Formatter(data, type, full) {
    var rc = "";
    var agi = full['AGI5'];
    var tierTypeAndOr = full['TierTypeAndOr5'];
    var a = full['AGI5a'];
    var comm = full['Comm5'];
    var potdesc = full['PayoutTypeDesc5'];

    if (parseInt(agi) > 0) {
        rc = '>=' + agi + '<br/>';
        if (tierTypeAndOr != null) {
            rc += tierTypeAndOr + ' >=' + a + '<br/>';
        }
        rc += formatDecimal2Raw(comm);
        if (potdesc != null) {
            rc += ' ' + potdesc;
        }
    }

    return rc;
}

//GetCompensationSchedOverview
function CompensationSchedOverviewTier6Formatter(data, type, full) {
    var rc = "";
    var agi = full['AGI6'];
    var tierTypeAndOr = full['TierTypeAndOr6'];
    var a = full['AGI6a'];
    var comm = full['Comm6'];
    var potdesc = full['PayoutTypeDesc6'];

    if (parseInt(agi) > 0) {
        rc = '>=' + agi + '<br/>';
        if (tierTypeAndOr != null) {
            rc += tierTypeAndOr + ' >=' + a + '<br/>';
        }
        rc += formatDecimal2Raw(comm);
        if (potdesc != null) {
            rc += ' ' + potdesc;
        }
    }

    return rc;
}

//GetCompensationSchedOverview
function CompensationSchedOverviewTier7Formatter(data, type, full) {
    var rc = "";
    var agi = full['AGI7'];
    var tierTypeAndOr = full['TierTypeAndOr7'];
    var a = full['AGI7a'];
    var comm = full['Comm7'];
    var potdesc = full['PayoutTypeDesc7'];

    if (parseInt(agi) > 0) {
        rc = '>=' + agi + '<br/>';
        if (tierTypeAndOr != null) {
            rc += tierTypeAndOr + ' >=' + a + '<br/>';
        }
        rc += formatDecimal2Raw(comm);
        if (potdesc != null) {
            rc += ' ' + potdesc;
        }
    }

    return rc;
}

//GuarMinFormatter
function GuarMinFormatter(data, type, full) {
    var pia = full['PayrollID_Advance'];

    if ((null != pia)) {
        return "$" + $.formatNumber(data, { format: "#,##0.00", locale: "us" });
    }
    else {
        return 'N/A';
    }

}

function formatAutoDrawAmt(data, type, full) {
    var result = data;
    if (full['PendingDraw'] == true) {
        result = 'Pending';
    }
    else {
        result = formatCurrency2DecimalRaw(data);
    }
    return result;
}

function formatMaxRecapture(data, type, full) {
    var result = data;
    if (data != null) {
        result = formatPercentage100Raw(data);
    }
    else {
        result = formatCurrency2DecimalRaw(full["MaxRecapAmount"]);
    }

    return result;
}

function formatCompensationSummaryPerEmpVariance(data, type, full) {
    var result = formatPercentage100With2DecimalRaw(data);

    if (type == "display") {
        var arrow = '<i class="fa fa-arrow-up" aria-hidden="true" style="color: green"></i>';
        if (data < 0) {
            arrow = '<i class="fa fa-arrow-down" aria-hidden="true" style="color: red"></i>';
        }

        result = result + " " + arrow;
    }

    return result;
}

function formatTotalLink(data, type, full) {
    var result = formatCurrency2DecimalRaw(data);
    if (full.LoanNo === '' || null === full.LoanNo) {
        result = "<a href='" + ResolveUrl("~/Reporting/Default.aspx") + "?ReportID=PayrollTransactions&EmpID=" + full["EmpID"] + "&LoanExclusion=1" + "'>" + result + "</a>";
    }
    return result;
}
